import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import createReactContext from '../context';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { hidableClass } from './styles';
var context = createReactContext({});
export var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, null, function (value) {
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, value, props))
        );
      })
    );
  };
};

/**
 * @param {*} Component
 * @param {*} duration
 * @param {*} type - fade, collapse, tranlate
 */
export default function (Component, _ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? ['fade'] : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 360 : _ref$duration,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'block' : _ref$display;
  var hasCollapse = type.indexOf('collapse') >= 0;
  var needTransform = type.indexOf('scale-y') >= 0;

  var Hidable =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Hidable, _PureComponent);

    var _super = _createSuper2(Hidable);

    function Hidable(props) {
      var _this;

      _classCallCheck(this, Hidable);

      _this = _super.call(this, props);
      _this.height = void 0;
      _this.id = void 0;
      _this.state = {
        show: props.show
      };
      _this.height = 0;
      _this.id = "__hidable_".concat(getUidStr(), "__");
      return _this;
    }

    _createClass(Hidable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        _get(_getPrototypeOf(Hidable.prototype), "componentDidMount", this).call(this);

        var el = this.getElement();
        if (!el) return;
        if (hasCollapse) this.height = el.offsetHeight;

        if (this.props.show) {
          this.show();
          return;
        }

        el.style.display = 'none';

        if (hasCollapse) {
          el.style.overflow = 'hidden';
          el.style.height = '0px';
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.show === prevProps.show) return;
        if (this.props.show) this.show();else this.hide();
      }
    }, {
      key: "getElement",
      value: function getElement() {
        return document.querySelector(".".concat(this.id));
      }
    }, {
      key: "show",
      value: function show() {
        var _this2 = this;

        var es = this.getElement().style;
        es.display = display;
        setTimeout(function () {
          if (_this2.$isMounted) {
            _this2.setState({
              show: true
            });

            if (hasCollapse) {
              es.height = "".concat(_this2.height, "px");
              setTimeout(function () {
                es.height = 'auto';
                es.overflow = '';
              }, duration);
            }
          }
        }, 10);
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this3 = this;

        this.setState({
          show: false
        });
        var element = this.getElement();

        if (hasCollapse) {
          this.height = element.offsetHeight;
          element.style.height = "".concat(this.height, "px");
          element.style.overflow = 'hidden';
          setTimeout(function () {
            element.style.height = '0px';
          }, 10);
        }

        setTimeout(function () {
          if (_this3.state.show === false && element) {
            element.style.display = 'none';
          }
        }, duration);
      }
    }, {
      key: "render",
      value: function render() {
        var animation = "animation-".concat(duration);

        if (!needTransform) {
          animation = "fade-".concat(animation);
        }

        var className = classnames(hidableClass.apply(void 0, ['_'].concat(_toConsumableArray(type), [animation, this.state.show && 'show'])), this.props.className, this.id);
        var provider = {
          visible: this.state.show
        };
        return (
          /*#__PURE__*/
          React.createElement(context.Provider, {
            value: provider
          },
          /*#__PURE__*/
          React.createElement(Component, Object.assign({}, this.props, {
            className: className
          })))
        );
      }
    }]);

    return Hidable;
  }(PureComponent);

  Hidable.defaultProps = {
    className: '',
    show: false
  };
  return Hidable;
}